import { MediaContentConfig } from '@goldcast/api/content';
import createStore from './store';
import { ContentStatesEnum, ContentError } from '@/Pages/VideoImportPage/constants';

export interface ContentUploadError {
  type: ContentError;
  message: string;
}

export type ContentUploadListItem = {
  projectId: string;
  contentId: string;
  duration?: number;
  file?: File;
  contentUrl?: string | null;
  contentState: ContentStatesEnum;
  error?: ContentUploadError | null;
  av_type: string;
  title: string;
  totalPercentageUploaded?: number;
  videoProcessingTime?: string;
  contentUploadedTime?: string;
  clipGenerationEstimatedTime?: string;
  showConfetti?: boolean;
};

export type ContentUploadState = {
  contentUploadList: { [contentId: string]: ContentUploadListItem };
  currentMediaContentConfig: MediaContentConfig | null;
};

export const contentUploadState = createStore<ContentUploadState>({
  contentUploadList: {},
  currentMediaContentConfig: null
});

export const updateMediaContentConfig = (mediaContentConfig: MediaContentConfig) => {
  contentUploadState.update((state: ContentUploadState) => {
    state.currentMediaContentConfig = mediaContentConfig;
  });
};

export const updateContentState = (newState: ContentStatesEnum, contentId: string) => {
  contentUploadState.update((state: ContentUploadState) => {
    state.contentUploadList[contentId].contentState = newState;
  });
};

export const updateTotalPercentageUploaded = (totalPercentageUploaded: number, contentId: string) => {
  contentUploadState.update((state: ContentUploadState) => {
    state.contentUploadList[contentId].totalPercentageUploaded = totalPercentageUploaded;
  });
};

export const setUploadContent = (contentDetails: ContentUploadListItem) => {
  contentUploadState.update((state: ContentUploadState) => {
    contentDetails.totalPercentageUploaded = 0;
    state.contentUploadList[contentDetails.contentId] = {
      ...state.contentUploadList[contentDetails.contentId],
      ...contentDetails
    };
  });
};

export const handleContentUploadError = (error: ContentUploadError, contentId: string) => {
  contentUploadState.update((state: ContentUploadState) => {
    state.contentUploadList[contentId].error = error;
  });
};

export const handleConfettiState = ({ showConfetti, contentId }) => {
  contentUploadState.update((state: ContentUploadState) => {
    state.contentUploadList[contentId].showConfetti = showConfetti;
  });
};

export const removeContentUploadEntry = (contentId: string) => {
  contentUploadState.update((state: ContentUploadState) => {
    delete state.contentUploadList[contentId];
  });
};
